import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { updateAboutPage } from "../../api/apiAbout";

export const useUpdateAboutPage = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const mutation = useMutation({
        mutationFn: (data) => updateAboutPage(data),
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ["about-page"] });
            toast.success(
                response?.message ||
                (isArabic ? "تم تحديث صفحة من نحن" : "About Page section updated")
            );
        },
        onError: (error) => {
            const message =
                error?.response?.data?.message ||
                (isArabic ? "تعذر التحديث" : "Failed to update");
            toast.error(message);
        },
    });

    return mutation;
};
